import React from 'react';
import t from 'react-translate';

// redux
import { useSelector } from 'react-redux';
import { getFlatCourseAliases } from 'redux/selectors/course';

// hooks
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { useDeleteLecture, useHideAddUIOnOpen } from 'lecture_pages/hooks/lecture-page-edit-top-panel';

// components
import TopPanelActionButton from './top-panel-action-button';
import { config } from '../../../../../config/config.json';

const DeleteLessonButton = () => {
  const params = useLecturePageParams();
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));
  const deleteThisLecture = useDeleteLecture();
  const hideAddUIOnOpen = useHideAddUIOnOpen();

  const handleDelete = () => {
    hideAddUIOnOpen();
    deleteThisLecture();
  };

  return (
    <React.Fragment>
      <TopPanelActionButton
        icon='trash'
        tooltipText={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.DELETE_LESSON(courseAliases)}
        iconClassName='text-danger'
        onClick={handleDelete}
        ariaLabel={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.DELETE_LESSON(courseAliases)}
        dataQa={config.pendo.lectureEdit.editMenuTopPanel.deleteLessonOption}
      />
    </React.Fragment>
  );
};

export default DeleteLessonButton;
